import { render, staticRenderFns } from "./accidentPictureTL.vue?vue&type=template&id=6e4d0aba"
import script from "./accidentPictureTL.vue?vue&type=script&lang=js"
export * from "./accidentPictureTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e4d0aba')) {
      api.createRecord('6e4d0aba', component.options)
    } else {
      api.reload('6e4d0aba', component.options)
    }
    module.hot.accept("./accidentPictureTL.vue?vue&type=template&id=6e4d0aba", function () {
      api.rerender('6e4d0aba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/timeline/accidentPictureTL.vue"
export default component.exports